// Lazily creates the per-key Map, so every "xFor" getter built on a WeakMap is a one-liner.
export const lazyMapFor = <Key extends object, MapKey, MapValue>(
  byKey: WeakMap<Key, Map<MapKey, MapValue>>,
  key: Key,
): Map<MapKey, MapValue> => {
  let map = byKey.get(key);
  if (!map) {
    map = new Map();
    byKey.set(key, map);
  }
  return map;
};
